import config_zastupko from "./zastupko/zastupko.target";
import config_most from "./most/most.target";

/**
 * Target represents configuration which is specific for each physical deploy.
 * 
 * @returns targetConfig
 */
const target = (rootConfig) => {

    let targetConfig = {};
    switch(rootConfig.target) {
        case "zastupko":
            targetConfig = config_zastupko(targetConfig);
        case "most":
            targetConfig = config_most(targetConfig);
        // todo local deploy for most, brno, ...
    }
    return targetConfig;
}
export default target;